import {DataStatus} from 'platform/components';

import {useGetTenantQuery} from '@dms/api/core';
import {useGetMonthlyStockTakeByIdQuery} from '@dms/api/reporting';

import {type RequiredTestIdProps, suffixTestId} from 'shared/web';

import {MonthlyStockTakeDetailContent} from './MonthlyStockTakeDetailContent';

const CONTENT_MIN_HEIGHT_STEPS = 60;

interface MonthlyStockTakeDetailDialogProps extends RequiredTestIdProps {
  id: string;
}

export function MonthlyStockTakeDetailDialog(props: MonthlyStockTakeDetailDialogProps) {
  const {
    data: detail,
    isFetching,
    isError,
  } = useGetMonthlyStockTakeByIdQuery(props.id, {
    refetchOnMountOrArgChange: true,
  });
  const {data: tenant, isLoading: isTenantLoading} = useGetTenantQuery();

  return (
    <DataStatus
      data={detail}
      isLoading={isFetching || isTenantLoading}
      isError={isError}
      minHeight={CONTENT_MIN_HEIGHT_STEPS}
      data-testid={suffixTestId('status', props)}
    >
      {({data}) => (
        <MonthlyStockTakeDetailContent
          detail={data}
          currency={tenant?.currency}
          data-testid={props['data-testid']}
        />
      )}
    </DataStatus>
  );
}
